import { createSelector } from 'reselect'

export default createSelector(
	[
		state => state.poll.entityUID,
		state => state.poll.timer.value,
	],
	(entityUID, timerValue) => ({
		entityUID,
		timerValue,
	})
)
